import './styles/globals.css';
import { Route, Switch, Redirect } from "react-router-dom";
import React, {useEffect} from "react";
import InstantReviews from './pages/InstantReviews'
import ReviewFormPage from './pages/ReviewFormPage'
import PageNotFound from './pages/PageNotFound'
import {
  ApolloProvider,
} from '@apollo/client'
import client from './apollo/apollo-client'

function App() {

  useEffect(() => {
    document.querySelector( "#loadingDiv" ).remove();
  }, [])

  return (
    <ApolloProvider client={client} >
      <Switch>
        <Route path="/:id" component={ReviewFormPage} exact />
        <Route path="/404" component={PageNotFound} exact />
        <Redirect from='*' to='/404' />
        <Route path="/" component={InstantReviews} exact />
      </Switch>
    </ApolloProvider>
  );
}

export default App;
